export default __webpack_public_path__ + "static/godaddy-054e842a65c847e73b7a1857a4782798.png";